import React, { useState } from 'react';
import { LoginForm } from './components/LoginForm';
import ChatInterface from './components/ChatInterface';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [token, setToken] = useState<string>('');
  const [userEmail, setUserEmail] = useState<string>('');

  const decodeJWT = (token: string): string => {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      console.log('JWT Payload:', payload); // Debug log
      return payload.given_name || payload.name?.split(' ')[0] || payload.email?.split('@')[0] || 'User';
    } catch (error) {
      console.error('JWT decode error:', error);
      return 'User';
    }
  };

  const handleAuthSuccess = (authToken: string) => {
    setToken(authToken);
    const email = decodeJWT(authToken);
    setUserEmail(email);
    setIsAuthenticated(true);
  };

  const handleSignOut = () => {
    localStorage.removeItem('meppy_token');
    setToken('');
    setUserEmail('');
    setIsAuthenticated(false);
  };

  if (!isAuthenticated) {
    return <LoginForm onAuthSuccess={handleAuthSuccess} />;
  }

  return (
    <div className="App">
      <header className="app-header">
        <div className="header-left">
          <img src="/meppy-avatar.png" alt="Meppy" className="meppy-avatar" />
          <div className="title-section">
            <h1>Meppy</h1>
            <p className="subtitle">Multi-Agent Methane Pyrolysis Research System</p>
          </div>
        </div>
        <div className="user-info">
          <span>Welcome, {userEmail}</span>
          <button onClick={handleSignOut} className="sign-out-btn">
            Sign Out
          </button>
        </div>
      </header>
      <div className="app-main">
        <ChatInterface token={token} />
      </div>
    </div>
  );
}

export default App;
